module.exports = __webpack_public_path__ + "img/background03.166b97a2.jpg";